import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_SRC = `${process.env.PUBLIC_URL}/assets/images/resources/stricky-logo.png`;

export default class LogoBox extends React.Component {
    render() {
        return (
            <>
                <style>{`
                    .header-logo-box {
                        position: relative;
                        display: flex;
                        align-items: center;
                        transition: max-width 0.2s ease;
                    }
                    /* Desktop & Large Screens (>= 1200px) - Client requested enlarged logo */
                    @media (min-width: 1200px) {
                        .header-logo-box {
                            max-width: 175px;
                            width: 175px;
                        }
                        .header-logo-box .header-logo-img {
                            width: 100%;
                            height: auto;
                            max-height: 110px;
                            object-fit: contain;
                            display: block;
                        }
                    }
                    /* Medium / Laptop Screens (992px - 1199px) */
                    @media (min-width: 992px) and (max-width: 1199px) {
                        .header-logo-box {
                            max-width: 155px;
                            width: 155px;
                        }
                        .header-logo-box .header-logo-img {
                            width: 100%;
                            height: auto;
                            max-height: 95px;
                            object-fit: contain;
                            display: block;
                        }
                    }
                    /* Tablet Screens (768px - 991px) */
                    @media (min-width: 768px) and (max-width: 991px) {
                        .header-logo-box {
                            max-width: 125px;
                            width: 125px;
                        }
                        .header-logo-box .header-logo-img {
                            width: 100%;
                            height: auto;
                            max-height: 80px;
                            object-fit: contain;
                            display: block;
                        }
                    }
                    /* Mobile Devices (<= 767px) - Perfectly aligned with mobile nav toggle */
                    @media (max-width: 767px) {
                        .header-logo-box {
                            max-width: 82px;
                            width: 82px;
                        }
                        .header-logo-box .header-logo-img {
                            width: 100%;
                            height: auto;
                            max-height: 60px;
                            object-fit: contain;
                            display: block;
                        }
                    }
                `}</style>
                <div className="logo-box header-logo-box"> 
                    <Link to={process.env.PUBLIC_URL + `/`} style={{ display: 'inline-block', width: '100%' }}>
                        <img 
                            className="img-fluid d-block header-logo-img" 
                            src={LOGO_SRC}
                            alt="Logo" 
                        />
                    </Link>
                </div>
            </>
        )
    }
}
